<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="academic_year"
                        rules="required"
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="formData.academic_year"
                                :validate-error="errors[0]"
                            ></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="price" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('price')">
                            <b-form-input
                                v-model="formData.price"
                                type="number"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="currency" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('currency')">
                            <currency-selectbox
                                :validate-error="errors[0]"
                                v-model="formData.currency"
                            ></currency-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="number_of_installments" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('number_of_installments')">
                            <b-form-input
                                type="number"
                                min="1" max="12"
                                v-model="formData.number_of_installments"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="12" v-if="formData.number_of_installments">
                    <b-col cols="12" md="12" v-if="formData.number_of_installments">
                        <b-form-group :label="$t('due_date')">
                            <div v-for="(date, index) in formData.due_dates" :key="index" class="mb-2">
                                <ValidationProvider
                                    :name="$t('installment_due_date') + ' #' + (index + 1)"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <b-form-input
                                        type="date"
                                        v-model="formData.due_dates[index]"
                                        :placeholder="$t('installment_due_date') + ' #' + (index + 1)"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="errors.length">{{ errors[0] }}</b-form-invalid-feedback>
                                </ValidationProvider>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="updateForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";

// Services
import PilotagePriceService from "@/services/PilotagePriceService";

// Other
import {ValidationProvider, ValidationObserver} from "vee-validate"

export default {
    components: {
        CurrencySelectbox,
        AcademicYearsSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {
                academic_year: null,
                price: null,
                currency: null,
                number_of_installments: null,
                due_dates: [],
            },
            formLoading: false,
        }
    },
    watch: {
        formId: function (val) {
            this.get(val)
        },
        'formData.number_of_installments'(newVal) {
            const count = Number(newVal);

            if (!count || count <= 0) {
                this.formData.due_dates = [];
                return;
            }

            const currentDates = this.formData.due_dates || [];

            this.formData.due_dates = currentDates
                .slice(0, count)
                .concat(Array(count - currentDates.length).fill(''));
        }

    },
    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            PilotagePriceService.get(id)
                .then(response => {
                    let data = response.data.data;
                    this.formData = {
                        academic_year:data.academic_year,
                        price:data.price,
                        currency:data.currency,
                        number_of_installments:data.number_of_installments,
                        due_dates:data.due_dates,
                    }
                })
                .catch(e => {
                    this.showErrors(e)
                })
        },

        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;
                PilotagePriceService.update(this.formId, this.formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false
                    })
            }
        }
    }
}
</script>
